import {UserPageTab, UserPageTabContent, UserPageWrap} from "src/styles/views/UserPage"
import {useLocation} from "react-router"
import UserPageMain from "src/views/UserPage/UserPageMain"
import UserPageLetter from "src/views/UserPage/Letter"
import UserPageFortune from "src/views/UserPage/Fortune"

const UserPage = () => {
    const {pathname} = useLocation()
    const UserPageOption = [
        {title: '마이페이지', component: <UserPageMain/>, path: '/userPage/main'},
        {title: '패밀리레터', component: <UserPageLetter/>, path: '/userPage/letter'},
        {title: '오늘의 운세', component: <UserPageFortune/>, path: '/userPage/fortune'},
    ]
    const FindItem = (element: { path: string }) => {
        return pathname.indexOf(element.path) === 0
    }

    return (
        <UserPageWrap>
            <UserPageTab>
                {UserPageOption.map((option: { title: string, component: JSX.Element, path: string }) => (
                    <UserPageTabContent
                        to={option.path === '/userPage/letter' ? '/userPage/letter/health' : option.path}
                        active={`${pathname.indexOf(option.path) === 0}`}
                        key={option.title}>
                        {option.title}
                    </UserPageTabContent>
                ))}
            </UserPageTab>
            {UserPageOption?.find(FindItem)?.component}
        </UserPageWrap>
    )
}


export default UserPage